import styled from "styled-components";
import MiniLoader from "../../../utils/MIniLoader";
import { useState } from "react";
import { ICON_CHEVRON_DOWN, ICON_CHEVRON_UP, ICON_EXCLAMATION } from "../../../utils/icons";
import { Link } from "react-router-dom";
import { Button } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import { useEffect } from "react";
import { naira } from "../../../utils/data";
import { formatDay, th } from "../../../utils/helpers";




const CurrentPlan = () => {

      const [load, setLoad] = useState(false);
      const [check_plan, setcheck_plan] = useState(false);

      function checkPlan() {
            setcheck_plan(!check_plan);
      }

      const {
            getCurrentSubscription, currentSubscription, loadingSubscription,

      } = useUserContext();

      useEffect(() => {
            getCurrentSubscription();
      }, []);

      const { amount, duration_days, expire, packageDetails, timestamp, bizData } = currentSubscription;

      const createdStore = bizData?.totalStore;
      const createdStaff = bizData?.totalStaff;


      return (
            <StyledCurrentPlan>

                  {/* Plan Title */}

                  <div className="border border-primary py-4 container br-md mt-4 ">
                        <h5>
                              Billing for Fireswitch
                        </h5>

                        {load === true ?
                              <div className="text-center my-5">
                                    <MiniLoader className="" load={load} />
                              </div> : (
                                    <>
                                          {true === false ? (
                                                <div className="grey-text text-center mt-2">
                                                      <span className="h1">
                                                            {ICON_EXCLAMATION}
                                                      </span>
                                                      <p>  No active Business Plan </p>
                                                </div>
                                          ) : (
                                                <p>Current billing period runs from <span className="fw-bold">
                                                      {formatDay(timestamp)}
                                                </span> to <span className="fw-bold">
                                                            {formatDay(expire)}
                                                      </span>.</p>
                                          )}
                                    </>)
                        }
                  </div>

                  {/* Plan Title */}

                  {/* Current Plan Details */}

                  <div className="mt-5">
                        {/* <div className=" ">
                              <h5 className='m-0 p-0'>
                                    Current Business Plan
                              </h5>
                        </div> */}
                        <div className="border border-primary py-4 container br-md mt-3 ">
                              <div className="d-flex justify-content-between border-bottom border-primary" onClick={checkPlan}>

                                    <div className="">
                                          <h5 className='m-0'>
                                                Business Plan
                                          </h5>
                                          <p className='m-0 p-0'>
                                                Fees and feature usage
                                          </p>
                                    </div>
                                    <span className="me-3">
                                          {check_plan ? ICON_CHEVRON_UP : ICON_CHEVRON_DOWN}
                                    </span>
                              </div>

                              {check_plan &&
                                    <div className="border-bottom border-primary mt-3">
                                          <div className="py-2  " >
                                                <h6 className="fw-bold ">Package Name: {packageDetails?.name}</h6>
                                                <h6 className="fw-bold">Amount: {naira}{th(amount)} </h6>
                                                <h6 className=" fw-bold"> Duration: {duration_days} days </h6>
                                          </div>
                                    </div>

                              }

                              {load === true ?
                                    <div className="text-center my-5">
                                          <MiniLoader className="" load={load} />
                                    </div> : (
                                          <>
                                                {true === false ? (
                                                      <div className="grey-text text-center mt-2">
                                                            <span className="h1">
                                                                  {ICON_EXCLAMATION}
                                                            </span>
                                                            <p>  No active Business Plan </p>
                                                      </div>
                                                ) : (
                                                      <div className="row mt-4">
                                                            <div className="col-md-4 mt-3 ">
                                                                  <h6 className="fw-bold">Free plan</h6>
                                                                  <small className="">Effective from                                                       {formatDay(timestamp)}
                                                                  </small>
                                                            </div>
                                                            <div className="col-md-4 mt-3 ">
                                                                  <h6 className="fw-bold">Usage</h6>
                                                                  <small>
                                                                        {createdStore} / {packageDetails?.no_locations} Store Created
                                                                  </small> <br />
                                                                  <small>
                                                                        {createdStaff} / {packageDetails?.no_users} Staff Added
                                                                  </small>
                                                            </div>
                                                            <div className="col-md-4 mt-3 ">
                                                                  <h6 className="fw-bold">Bill</h6>
                                                                  <h6 className="mt-3 fw-bold">
                                                                        {naira}{th(amount)}
                                                                  </h6>
                                                            </div>
                                                      </div>
                                                )}
                                          </>
                                    )}
                              <div className="text-center mt-4">
                                    <Link to="/user/settings/packages">

                                          <Button pry className='btn w-md-100'>
                                                {localStorage.getItem('active') === '1' ? 'Change Business Plan' : 'Upgrade'
                                                }
                                          </Button>
                                    </Link>
                              </div>

                        </div>
                  </div>

                  {/* Current Plan Details */}

            </StyledCurrentPlan>
      );
};

export default CurrentPlan;

const StyledCurrentPlan = styled.section`
      
color: var(--pry-bold-color);
` ;